import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import shallow from "zustand/shallow";

import Image_ from "../Image";
import MarkdownBlock from "../Markdown";
import Button from "../NewForms/Button";
import SmallShapeContainer from "../SmallShapeContainer";
import useStore, { iProductPackage } from "./store";

const Card = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    ${({ theme }) => theme.breakpoints.from.small.css`
        max-width: 100%;
    `}
    ${({ theme }) => theme.breakpoints.from.medium.css`
        max-width: 45%;
    `}
    ${({ theme }) => theme.breakpoints.from.large.css`
        width: 40%;
    `}

    margin: 0 atuo;
    overflow: hidden;
`;

const Image = styled(Image_)`
    height: 250px;
    ${(p) => css`
        background-position: ${p.imgPositionX} ${p.imgPositionY};
    `}
    ${({ theme }) => theme.breakpoints.from.medium.css`
        height: 300px;
    `}
`;

interface iProps {
    productPackage: iProductPackage;
    contactFormId?: string;
}

const WorkshopProductPackageItem = ({
    productPackage,
    contactFormId,
}: iProps) => {
    const [activeProduct, setActiveProduct] = useStore(
        (state) => [state.activeProduct, state.setActiveProduct],
        shallow
    );
    const handleClick = () => {
        setActiveProduct(productPackage);
        if (contactFormId) {
            const element = document.getElementById(contactFormId);
            if (element) {
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }
    };

    return (
        <Card>
            <SmallShapeContainer
                isActive={activeProduct === productPackage}
                css={css`
                    margin: 0 auto;
                `}
            >
                <SmallShapeContainer.ImageContainer>
                    {productPackage.image?.src && (
                        <Image {...productPackage.image} />
                    )}
                </SmallShapeContainer.ImageContainer>

                <SmallShapeContainer.TextContainer>
                    <b>{productPackage.headline}</b>
                    <MarkdownBlock>{productPackage.text}</MarkdownBlock>
                    <Button onClick={handleClick} text small underline>
                        Jetzt anfragen
                    </Button>
                </SmallShapeContainer.TextContainer>
            </SmallShapeContainer>
        </Card>
    );
};

export default WorkshopProductPackageItem;
